import React from "react";

import LogoImage from "shared/assets/logo.png";
import { Box } from "@mui/material";

export function Logo() {
  return (
    <Box
      component="img"
      src={LogoImage}
      alt="iNovitas Logo"
      id="logo"
      sx={{
        width: "100%",
        height: "100%",
        objectFit: "contain",
      }}
    />
  );
}
